/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free statistics calculator. Paste a list of numbers to get the mean, median, mode, range, variance and standard deviation instantly.`)
};

const es_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de estadística gratuita. Pega una lista de números para obtener al instante la media, mediana, moda, rango, varianza y desviación estándar.`)
};

const de_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Statistik-Rechner. Füge eine Zahlenliste ein, um sofort Mittelwert, Median, Modus, Spannweite, Varianz und Standardabweichung zu erhalten.`)
};

const nl_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis statistiek calculator. Plak een lijst met getallen om direct het gemiddelde, de mediaan, modus, spreidingsbreedte, variantie en standaardafwijking te krijgen.`)
};

const fr_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de statistiques gratuit. Collez une liste de nombres pour obtenir instantanément la moyenne, la médiane, le mode, l'étendue, la variance et l'écart-type.`)
};

const it_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di statistica gratuito. Incolla un elenco di numeri per ottenere subito media, mediana, moda, intervallo, varianza e deviazione standard.`)
};

const pt_br2_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de estatística gratuita. Cole uma lista de números para obter a média, mediana, moda, amplitude, variância e desvio padrão instantaneamente.`)
};

const pt_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de estatística gratuita. Cole uma lista de números para obter instantaneamente a média, mediana, moda, amplitude, variância e desvio-padrão.`)
};

const ja_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の統計計算機。数値のリストを貼り付けるだけで、平均値、中央値、最頻値、範囲、分散、標準偏差を瞬時に算出します。`)
};

const zh_st_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费统计计算器。粘贴一组数字，即可立即获得平均数、中位数、众数、极差、方差和标准差。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_meta_description", locale)
	if (locale === "en") return en_st_meta_description(inputs)
	if (locale === "es") return es_st_meta_description(inputs)
	if (locale === "de") return de_st_meta_description(inputs)
	if (locale === "nl") return nl_st_meta_description(inputs)
	if (locale === "fr") return fr_st_meta_description(inputs)
	if (locale === "it") return it_st_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_st_meta_description(inputs)
	if (locale === "pt") return pt_st_meta_description(inputs)
	if (locale === "ja") return ja_st_meta_description(inputs)
	return zh_st_meta_description(inputs)
};